// Instant faceted filtering via Shopify's Section Rendering API. Progressive
// enhancement over the reload baseline (facets.liquid's real <form method="get">
// + real <a> links). Only intercepts events it can handle; with JS off every
// control still works via normal navigation.
(function () {
  var root = document.querySelector('[data-section-id]');
  if (!root) return;
  var sectionId = root.getAttribute('data-section-id');
  var reqSeq = 0;            // monotonically increasing request id (drop stale responses)
  var drawerOpen = false;    // persist mobile drawer state across section swaps
  var drawerScroll = 0;

  function stripSection(u) { u.searchParams.delete('section_id'); return u.pathname + u.search; }
  function currentForm() { return root.querySelector('[data-facets-form]'); }

  function submitForm() {
    var form = currentForm();
    if (!form) return;
    // Serialize the form, but drop empty facet values (blank price min/max) and the default
    // `manual` sort so clearing every real filter returns to a clean base URL — otherwise the
    // leftover `filter.v.price.gte=` / `sort_by=manual` params keep in-stock-first from resuming.
    var params = new URLSearchParams();
    new URLSearchParams(new FormData(form)).forEach(function (value, key) {
      if (value === '') return;
      if (key === 'sort_by' && value === 'manual') return;
      params.append(key, value);
    });
    var qs = params.toString();
    fetchAndSwap(location.pathname + (qs ? '?' + qs : ''));
  }

  // Debounce rapid multi-filter selection into ONE fetch+swap. Each tap still gets
  // instant feedback (is-loading added synchronously), but we only re-query 250ms
  // after the last change. Selecting size 9 + 9.5 + 10 is now a single swap instead
  // of three overlapping ones piling up on the main thread — that pile-up was
  // spiking INP on collection pages and driving filter rage-taps.
  var submitTimer = null;
  function scheduleSubmit() {
    root.classList.add('is-loading'); // instant visual feedback on every tap
    clearTimeout(submitTimer);
    submitTimer = setTimeout(submitForm, 250);
  }

  // push defaults to true; popstate passes false so restoring history doesn't push.
  function fetchAndSwap(url, push) {
    var myReq = ++reqSeq;
    var u = new URL(url, location.origin);
    u.searchParams.set('section_id', sectionId);
    // Remember the drawer's scroll position before we tear it down.
    var scroller = root.querySelector('[data-facets] .facets__form');
    if (drawerOpen && scroller) drawerScroll = scroller.scrollTop;
    root.classList.add('is-loading');
    fetch(u.toString(), { headers: { 'X-Requested-With': 'fetch' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        if (myReq !== reqSeq) return; // a newer request superseded this one
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-section-id]');
        if (fresh) {
          root.innerHTML = fresh.innerHTML; // swap facets + grid together
          if (push === 'replace') history.replaceState({}, '', stripSection(u));
          else if (push !== false) history.pushState({}, '', stripSection(u));
          bind();                            // re-bind on the fresh nodes
          if (drawerOpen) reopenDrawer();    // keep the drawer open after a swap
        }
      })
      .catch(function () {
        if (myReq === reqSeq) location.href = stripSection(u); // fall back to navigation
      })
      .finally(function () {
        if (myReq === reqSeq) root.classList.remove('is-loading');
      });
  }

  function setDrawer(open) {
    drawerOpen = open;
    var facets = root.querySelector('[data-facets]');
    var backdrop = root.querySelector('[data-facets-backdrop]');
    if (facets) facets.classList.toggle('is-open', open);
    if (backdrop) backdrop.classList.toggle('is-open', open);
    document.documentElement.classList.toggle('facets-lock', open);
  }

  function reopenDrawer() {
    var facets = root.querySelector('[data-facets]');
    // Suppress the slide-in transition on the re-inserted drawer, then restore scroll.
    if (facets) {
      facets.style.transition = 'none';
      setDrawer(true);
      // Force a reflow so removing the override doesn't animate this frame.
      void facets.offsetWidth;
      facets.style.transition = '';
    } else {
      setDrawer(true);
    }
    var scroller = root.querySelector('[data-facets] .facets__form');
    if (scroller) scroller.scrollTop = drawerScroll;
  }

  function bind() {
    // Facet checkboxes / price inputs live inside the form → its change re-queries
    // (debounced so multi-select batches into one swap).
    var form = currentForm();
    if (form) form.addEventListener('change', scheduleSubmit);

    // The sort <select> sits in the top bar but is associated to the form via
    // form="facets-form", so it is outside the form's DOM subtree — bind it
    // directly. Null its inline onchange (no-JS fallback) so it doesn't reload.
    var sortSel = root.querySelector('[data-sort]');
    if (sortSel) { sortSel.onchange = null; sortSel.addEventListener('change', scheduleSubmit); }

    // Chip removal + clear + pagination → intercept and swap (and close drawer).
    root.querySelectorAll('[data-active-filters] a, .facets__clear, .w-pagination-previous, .w-pagination-next').forEach(function (a) {
      a.addEventListener('click', function (e) { e.preventDefault(); setDrawer(false); fetchAndSwap(a.href); });
    });

    // Open the drawer (mobile Filter button).
    var openBtn = root.querySelector('[data-open-facets]');
    if (openBtn) openBtn.addEventListener('click', function () { setDrawer(true); });

    // Close the drawer (header ✕ and the "View N products" button both carry it).
    root.querySelectorAll('[data-close-facets]').forEach(function (b) {
      b.addEventListener('click', function () { setDrawer(false); });
    });
    var backdrop = root.querySelector('[data-facets-backdrop]');
    if (backdrop) backdrop.addEventListener('click', function () { setDrawer(false); });
  }

  // Window/document listeners are attached ONCE (not in bind) to avoid stacking.
  // Sibling scripts (sola-instock-filter.js's first-load guard) can request an in-app swap
  // instead of a full navigation; mode 'replace' keeps history clean like location.replace.
  root.addEventListener('sola:swap', function (e) {
    var d = e.detail || {};
    if (d.url) fetchAndSwap(d.url, d.mode === 'replace' ? 'replace' : undefined);
  });
  window.addEventListener('popstate', function () { setDrawer(false); fetchAndSwap(location.href, false); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && drawerOpen) setDrawer(false); });

  bind();
})();
